<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                                <strong>{{$t('addReminder')}}</strong>
                            </CCol>
                            <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                                <CButton
                                        class="mr-1"
                                        size="sm"
                                        color="secondary"
                                        @click="insert_data"
                                >{{ $t("buttons.submit") }}
                                </CButton>
                            </CCol>

                        </CRow>
                    </CCardHeader>
                    <CCardBody>

                        <CRow>
                            <CCol>
                                <CSelect horizontal
                                         :value.sync="CategoryId"
                                         :options="reminder_categories"
                                         :label="$t('tables.category')"/>
                            </CCol>
                            <CCol>
                                <CSelect horizontal
                                         :value.sync="PriorityId"
                                         :options="priority_items"

                                         :label="$t('priority')"/>

                            </CCol>

                            <CCol>
                                <CSelect horizontal
                                         :value.sync="StatusId"
                                         :options="status_items"
                                         :label="$t('tables.status')"/>

                            </CCol>
                            <CCol>
                                <CRow form class="form-group">
                                    <CCol tag="label" sm="3" class="col-form-label">
                                        {{$t('date')}}
                                    </CCol>
                                    <CCol sm="9">
                                        <date-picker
                                                v-model="StartDate"></date-picker>
                                    </CCol>
                                </CRow>
                            </CCol>


                        </CRow>
                        <CRow>
                            <CCol>
                                <CRow form class="form-group">
                                    <CCol tag="label" sm="3" class="col-form-label">
                                        {{$t('time')}}
                                    </CCol>
                                    <CCol sm="9">
                                        <date-picker
                                                v-model="StartTime"
                                                type="time"
                                                display-format="HH:mm"
                                                format="HH:mm"
                                                input-format="HH:mm"></date-picker>
                                    </CCol>
                                </CRow>
                            </CCol>


                            <CCol>
                                <CRow form class="form-group">
                                    <CCol tag="label" sm="3" class="col-form-label">
                                        {{$t('alarmDate')}}
                                    </CCol>
                                    <CCol sm="9">
                                        <date-picker
                                                v-model="AlarmDate"></date-picker>
                                    </CCol>
                                </CRow>
                            </CCol>
                            <CCol>
                                <CSelect horizontal
                                         :value.sync="AlarmTime"
                                         :options="[{label:this.$t('halfHourBefore'),value:0.5},
                                     {label:this.$t('oneHourBefore'),value:1},
                                     {label:this.$t('oneHourAndhalfBefore'),value:1.5},
                                     {label:this.$t('twoHourBefore'),value:2},
                                     {label:this.$t('twoHourAndhalfBefore'),value:2.5},
                                     {label:this.$t('threeHourBefore'),value:3}]"
                                         :label="$t('alarmTime')"/>

                            </CCol>
                            <CCol>
                                <CSelect horizontal
                                         :value.sync="ReminderRepeat"
                                         :options="Repeat_options"
                                         :label="$t('repeat')"/>

                            </CCol>


                        </CRow>

                        <CRow v-if="ReminderRepeat==77">
                            <CCol>
                                <CInputCheckbox
                                        :label="$t('allDays')"
                                        :checked.sync="week_days_all"
                                />
                            </CCol>
                            <CCol>
                                <CInputCheckbox
                                    :label="$t('saturday')"
                                        :checked.sync="week_days[0]"

                                />
                            </CCol>
                            <CCol>
                                <CInputCheckbox
                                    :label="$t('sunday')"
                                        :checked.sync="week_days[1]"
                                />
                            </CCol>
                            <CCol>
                                <CInputCheckbox
                                    :label="$t('monday')"
                                        :checked.sync="week_days[2]"
                                />
                            </CCol>
                            <CCol>
                                <CInputCheckbox
                                    :label="$t('tuesday')"
                                        :checked.sync="week_days[3]"
                                />
                            </CCol>
                            <CCol>
                                <CInputCheckbox
                                    :label="$t('wednesday')"
                                        :checked.sync="week_days[4]"
                                />
                            </CCol>
                            <CCol>
                                <CInputCheckbox
                                    :label="$t('thursday')"
                                        :checked.sync="week_days[5]"
                                />
                            </CCol>

                            <CCol>
                                <CInputCheckbox
                                    :label="$t('friday')"
                                        :checked.sync="week_days[6]"
                                />
                            </CCol>
                        </CRow>
                        <br>
                        <CRow>
                            <CCol col="6">

                                <CRow form class="form-group" style="margin-right: -35px">
                                    <CCol tag="label" sm="2" class="col-form-label">
                                        {{$t('title')}}
                                    </CCol>
                                    <CCol sm="10">
                                        <CInput


                                                v-model="Note"
                                        />
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol>
                                <CRow>
                                    <CCol>
                                        <CRow form class="form-group">
                                            <CCol tag="label" sm="3" class="col-form-label">
                                                {{$t('router.users')}}
                                            </CCol>
                                            <CCol sm="9">
                                              <treeselect
                                                  v-model="PersonId"
                                                  :async="true"
                                                  :load-options="load_persons"
                                                  @select="select_user"
                                                  :multiple="true"
                                                  :placeholder="$t('components.search')"
                                                  :normalizer="normalizer_contact"
                                              />
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                    <CCol>
                                        <CRow form class="form-group" style="margin-right: -35px">
                                            <CCol tag="label" sm="3" class="col-form-label">
                                                {{$t('contacts')}}
                                            </CCol>
                                            <CCol sm="9">


                                              <CDataTable
                                                  :items="contacts"
                                                  :fields="contacts_fields"
                                                  :items-per-page="10"
                                                  hover
                                                  striped
                                                  border
                                                  pagination
                                              >
                                                <template #select="{item,index}">

                                                  <td >
                                                    <input name="contacts[]" type="checkbox" v-model="selected_contacts"
                                                           :value="item.userId">

                                                  </td>

                                                </template>
                                              </CDataTable>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                </CRow>
                            </CCol>
                            <CCol col="6">

                                <CRow form class="form-group" style="margin-right: -35px">
                                    <CCol tag="label" sm="2" class="col-form-label" >
                                        {{$t('tables.summary')}}
                                    </CCol>
                                    <CCol sm="10">
                                        <CTextarea

                                                :rows="5"
                                                v-model="Summary"
                                        />
                                    </CCol>
                                </CRow>
                            </CCol>


                        </CRow>
                        <CRow>
                        </CRow>


                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Vue from 'vue'
    import BTabs from "../../tabs/BTabs";
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }

    var items = [];

    export default {
        name: 'Login',
        components: {Treeselect},
        data() {
            return {
                PersonId: null,
                PersonIdContact: null,
                Note: '',
                ContactName: '',
                ReminderType: '',
                CategoryId: '',
                StatusId: '',
                PriorityId: '',
                StartDate: '',
                StartTime: '',
                AlarmDate: '',
                Summary: '',
                AlarmTime: 0.5,
                async_user: true,
                contacts: [],
              selected_contacts: [],
                ReminderRepeat: 0,
                reminder_categories: [],
                reminder_types: [],
                priority_items: [],
              contacts_fields: [
                {key: 'select', label: this.$t('tables.row'), _style: 'width:20%'},
                {key: 'userName', label: this.$t('contact'), _style: 'width:80%'},

                  ],
                status_items: [],
                Repeat_options: [],
                week_days: [true, true, true, true, true, true, true],
                week_days_all: true,

                load_persons({action, searchQuery, callback}) {

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);
                            var url = "GetAllPersons";

                            formData.append('IsVendor', false);
                            formData.append('IsWorker', true);
                            formData.append('IsCustomer', false);
                            formData.append('IsActive', 0);

                            axios.post(url, formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                            })
                                .catch(function (error) {

                                    console.log(error);
                                });

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.userName + " " + node.surName,
                    }
                },
                normalizer_contact(node) {
                    return {
                        id: node.userId,
                        label: node.userName,
                    }
                },
            }
        }, mounted() {
            this.$root.root_validate_errors = [];
            this.reminder_cats()
            this.get_sys()
            this.get_contacts()

        }, watch: {
            'week_days_all': function () {
                if (this.week_days_all) {
                    this.week_days = [true, true, true, true, true, true, true];

                } else {
                    this.week_days = [false, false, false, false, false, false, false];

                }
            },
            'active_tab': function () {
                localStorage.setItem("inventory_setting_active_tab", this.active_tab)
            }
        },
        methods: {
            get_alarm_time() {
                return moment(this.StartTime, 'HH:mm').subtract(this.AlarmTime * 60, 'minute').format('HH:mm');
            },
            select_user(node) {
                this.ContactName = node.userName + " " + node.surName

            },
            get_contacts() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);

                axios.post('GetPersonUserContacts', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.contacts = [];
                        var my_contacts = [];
                        content_data.data.forEach(val => {
                            self.contacts.push({userName: val.contactName, surName: val.surName, userId: val.contactId})
                        });

                        // Vue.set(self.contacts, my_contacts)
                        self.async_user = false

                        setTimeout(() => {
                            self.async_user = true

                        }, 1000);
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            validateForm: function () {
                this.$root.root_validate_errors = [];


                if (this.StartDate != '' && this.StartTime != '' && this.AlarmDate != '') {
                    return true;
                } else {
                    this.$root.root_validate_errors.push(this.$t('selectDate'));

                }
                if (this.Note == '') {
                    this.$root.root_validate_errors.push(this.$t('insertTitle'));
                }


                return false;
            },
            insert_data() {


                if (!this.validateForm()) {
                    // console.log("validate form is false"+this.validate_errors);
                    return true;
                }

                let self = this;
                const formData = new FormData();
                let url = "AddUserReminder";


                formData.append('PersonId', 0);

                formData.append('Title', this.Note);
                formData.append('Note', this.Summary);
                formData.append('ContactName', this.ContactName);
                formData.append('ReminderType', this.ReminderType);
                formData.append('CategoryId', this.CategoryId);
                formData.append('StatusId', this.StatusId);
                formData.append('PriorityId', this.PriorityId);
                formData.append('StartDate', this.StartDate);
                formData.append('StartTime', this.StartTime);
                formData.append('AlarmDate', this.AlarmDate);
                formData.append('Summary', this.Summary);
                for (var x = 0; x < this.PersonId.length; x++) {

                    formData.append('Contacts[]', this.PersonId[x]);

                }for (var z = 0; z < this.selected_contacts.length; z++) {

                    formData.append('Contacts[]', this.selected_contacts[z]);

                }
                formData.append('Repeat', this.ReminderRepeat);
                var days = [];
                for (var i = 0; i < this.week_days.length; i++) {
                    if (this.week_days[i]) {
                        days.push({"DayId": i, DayTitle: ""});
                    }
                }
                formData.append('JsonDays', JSON.stringify(days));
                formData.append('AlarmTime', this.get_alarm_time());

                axios.post(url, formData, {}).then((res) => {
                    self.$root.modal_component.show_api_response_modals(res);
                    if (res.data.statusCode == 0) {
                        self.PersonId = null;
                        self.Note = '';
                        self.Summary = '';
                        self.PersonId = null;
                        self.ContactName = '';
                        self.StartDate = '';
                        self.StartTime = '';
                        self.AlarmDate = '';
                        bus.$emit("update_reminder", "");

                    }

                }).catch(function (error) {
                    console.log(error);
                });

            },
            reminder_cats() {

                let self = this;
                const formData = new FormData();
                let url = "GetReminderCategoryList";
                // formData.append('file', this.file);

                axios.post(url, formData, {}).then((res) => {

                    self.reminder_categories = self.sort_array(
                        [], res.data.data,
                        'id', 'title');

                    self.CategoryId = self.reminder_categories[0].value;
                }).catch(function (error) {
                    console.log(error);
                });

            },
            get_sys() {
                var self = this;

                const formData = new FormData();

                axios.post('GetSysPersonGlobals', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.doc_types = [];

                    self.Repeat_options = [{label: self.$t('noRepeat'), value: 0}]
                    content_data.forEach((val) => {
                        var obj = {label: val.title, value: val.id}

                        if (val.titleType == 23) {
                            self.reminder_types.push(obj);
                        }
                        if (val.titleType == 18) {
                            self.priority_items.push(obj);
                        }
                        if (val.titleType == 15) {
                            self.status_items.push(obj);
                        }
                        if (val.titleType == 23) {
                            self.Repeat_options.push(obj);
                        }
                    });
                    self.ReminderType = self.reminder_types[0].value
                    self.PriorityId = self.priority_items[0].value
                    self.StatusId = self.status_items[0].value

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
        }
    }

</script>
